// @flow

import type {Language} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import GoSearch from 'react-icons/lib/go/search'

import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  fetchPortfolioCompanies: () => void,
  resetPortfolioCompaniesSortOptions: () => void,
  setPortfolioSearchFilter: (string) => void,
  setPortfolioPageNumber: (number) => void,
  portfolioSearchFilter: string,
  l: Language,
}

const RawSearchCompanies = (props: Props) => {
  const getCompanies = () => {
    props.setPortfolioPageNumber(0)
    props.resetPortfolioCompaniesSortOptions()
    props.fetchPortfolioCompanies()
  }

  const onKeyChange = (e) => {
    if (e.key === 'Enter') {
      getCompanies()
    }
  }

  const onSearchInputChange = (e) => {
    const input = e.currentTarget.value
    props.setPortfolioSearchFilter(input)
    if (input === '') {
      getCompanies()
    }
  }
  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        placeholder={props.l('Search')}
        value={props.portfolioSearchFilter}
        onKeyPress={onKeyChange}
        onChange={onSearchInputChange}
      />
      <span className="input-group-btn">
        <button id="search_companies"
          className="btn btn-success"
          type="button"
          onClick={getCompanies}
        >
          <GoSearch />
        </button>
      </span>
    </div>
  )
}

const mapStateToProps = (state) => ({
  portfolioSearchFilter: state.ui.portfolioSearchFilter,
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawSearchCompanies)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/search-companies.js